@if (userStore.initialized() && userStore.commune() && userStore.isLoggedIn()) {
  <app-authenticated-dashboard></app-authenticated-dashboard>
}

<app-tool-overlay></app-tool-overlay>
